export default __webpack_public_path__ + "static/media/html.d503d4af.svg";